import custom from './custom'

const pageRouters = [
  custom
]

export default pageRouters



// WEBPACK FOOTER //
// ./src/router/pageRouters.js